import { SET_LOGIN_TOKEN } from "../types/authType";

// Action Functions
export const setLoginToken = (token: string) => ({
  type: SET_LOGIN_TOKEN,
  payload: token,
});
